import { configure } from 'arktype/config';

// TODO: Remove this in the future and enable "exactOptionalPropertyTypes" in tsconfig.json
//       This is a bigger change though. That is why also arktype needs to handle optional fields like ts does.
configure({ exactOptionalPropertyTypes: false });
